const HTML_LINE_INDENT = /^[ \t]+(?=<\/?[a-zA-Z][^>]*>)/;
const FENCE = /^\s{0,3}(`{3,}|~{3,})/;

/**
 * Agents often emit pretty-printed HTML with blank lines between elements. A blank line closes
 * a markdown HTML block, so any following line indented four or more spaces is parsed as an
 * indented code block and its tags render as literal text instead of markup. Pulling tag lines
 * back to column zero keeps them as HTML blocks. Fenced regions are left untouched so genuine
 * code samples still render as code.
 */
export function normalizeChatMarkdown(markdown) {
  if (typeof markdown !== 'string' || !markdown.includes('<')) return markdown;

  let openFence = null;
  let changed = false;

  const lines = markdown.split('\n').map(line => {
    const fence = line.match(FENCE);

    if (fence) {
      const marker = fence[1][0];
      if (!openFence) openFence = marker;
      else if (openFence === marker) openFence = null;
      return line;
    }

    if (openFence) return line;

    const dedented = line.replace(HTML_LINE_INDENT, '');
    if (dedented !== line) changed = true;
    return dedented;
  });

  return changed ? lines.join('\n') : markdown;
}

export default normalizeChatMarkdown;
